import { render, staticRenderFns } from "./ImgScreen.vue?vue&type=template&id=7052b2df&scoped=true&lang=pug&"
import script from "./ImgScreen.vue?vue&type=script&lang=js&"
export * from "./ImgScreen.vue?vue&type=script&lang=js&"
import style0 from "./ImgScreen.vue?vue&type=style&index=0&id=7052b2df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7052b2df",
  null
  
)

export default component.exports